"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_popper_tooltip_1 = __importDefault(require("react-popper-tooltip"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
function Popover(_a) {
    var children = _a.children, Icon = _a.icon, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.column, column = _c === void 0 ? false : _c;
    var _d = React.useState(false), visibility = _d[0], setVisibility = _d[1];
    var className = classnames_1.default("nimbus--keyboard-toolbar-button", {
        "is--active": visibility,
    });
    function InternalTooltip(_a) {
        var tooltipRef = _a.tooltipRef, getTooltipProps = _a.getTooltipProps;
        var popoverClassName = classnames_1.default("nimbus--keyboard-toolbar-popover", {
            "is--column": column,
        });
        var tooltipProps = getTooltipProps({
            ref: tooltipRef,
            className: popoverClassName,
        });
        return (React.createElement("div", __assign({}, tooltipProps, { role: "dialog" }), children));
    }
    function Trigger(_a) {
        var getTriggerProps = _a.getTriggerProps, triggerRef = _a.triggerRef;
        var triggerProps = getTriggerProps({
            ref: triggerRef,
            className: "nimbus--keyboard-toolbar-button__wrapper",
        });
        return (React.createElement("span", __assign({}, triggerProps, { role: "tooltip", "aria-label": label, type: "button", disabled: disabled }),
            React.createElement("div", { className: className }, Icon ? (React.createElement(Icon, null)) : (React.createElement(__1.Text, { size: "small", block: true }, label)))));
    }
    var handleVisibilityChange = function (value) { return setVisibility(value); };
    return (React.createElement(react_popper_tooltip_1.default, { placement: "top-start", trigger: "click", tooltip: InternalTooltip, onVisibilityChange: handleVisibilityChange }, Trigger));
}
exports.default = Popover;
//# sourceMappingURL=KeyboardToolbar.Popover.js.map